import * as React from 'react';
import classnames from 'classnames';
import { Card, Alert, MediaQuery } from '@grandvisionhq/common';
import { FormCard, Field, Util, CheckboxView, ConnectedFormSelect } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { placeholderImage } from '@grandvisionhq/utils';
import { createFieldIds } from '../../utils/create-field-ids.js';
import { SelectReason } from './SelectReason/SelectReason.js';

const createQuantitySelectOptions = (quantity)=>{
    const quantityObject = {};
    for(let i = 1; i <= quantity; i++){
        quantityObject[i.toString()] = {
            label: `${i}`,
            value: `${i}`
        };
    }
    return quantityObject;
};
const ReturnItem = ({ item , id , required , isOnlyItem , returnReasons ,  })=>{
    const { displayName , imageSrc , quantity  } = item;
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    const { getLabel  } = useIntl();
    const [checked, setChecked] = React.useState(false);
    const inputNames = createFieldIds(id);
    const respondToFormFields = (()=>{
        if (checked) {
            if (item.quantity > 1) {
                return [
                    inputNames.checkbox,
                    inputNames.reason,
                    inputNames.quantity
                ];
            }
            return [
                inputNames.checkbox,
                inputNames.reason
            ];
        } else if (isOnlyItem) {
            return [
                inputNames.reason
            ];
        } else {
            return [
                inputNames.checkbox
            ];
        }
    })();
    const returnReasonOptions = returnReasons === null || returnReasons === void 0 ? void 0 : returnReasons.map(({ key , value  })=>({
            label: value,
            value: key
        })
    );
    return /*#__PURE__*/ React.createElement(FormCard, {
        layout: isPhone ? 'vertical' : 'horizontal',
        className: "return-item",
        selected: checked,
        respondToFormFields: respondToFormFields
    }, /*#__PURE__*/ React.createElement(Card.Content, {
        childrenWrapperClassName: "return-item__top-container",
        className: "return-item__card-content--top"
    }, /*#__PURE__*/ React.createElement("img", {
        alt: displayName || '',
        src: imageSrc || placeholderImage.url,
        className: classnames('return-item__image', {
            'return-item__image--placeholder': !imageSrc
        })
    }), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "return-item__info"
    }, !isOnlyItem ? /*#__PURE__*/ React.createElement(Field, {
        name: inputNames.checkbox,
        error: "" // do something here?
        ,
        onChange: ()=>setChecked(!checked)
        ,
        className: classnames('return-item__checkbox', [
            {
                'sr-only': isOnlyItem
            }, 
        ]),
        value: displayName,
        validations: required ? [
            Util.validations.isRequired
        ] : undefined
    }, /*#__PURE__*/ React.createElement(CheckboxView, {
        id: inputNames.checkbox,
        label: "",
        onChange: ()=>null
        ,
        value: displayName,
        checked: isOnlyItem ? true : checked
    })) : null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Card.Heading, {
        component: "h2"
    }, displayName)))), (isOnlyItem || checked) && (returnReasonOptions || quantity) ? /*#__PURE__*/ React.createElement(Card.Content, {
        className: "return-item__card-content--selectors"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "return-item__selectors"
    }, (returnReasonOptions === null || returnReasonOptions === void 0 ? void 0 : returnReasonOptions.length) ? /*#__PURE__*/ React.createElement("div", {
        className: "return-item__selectors-container"
    }, /*#__PURE__*/ React.createElement(SelectReason, {
        id: inputNames.reason,
        name: inputNames.reason,
        label: getLabel('returns.page.selectItems.field.returnReason.label'),
        placeholder: getLabel('returns.page.selectItems.field.returnReason.placeholder'),
        errorMessage: getLabel('returns.page.selectItems.field.returnReason.error'),
        className: "return-item__select",
        required: true,
        initialState: undefined,
        options: returnReasonOptions
    })) : /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        icon: "alert-circle",
        message: getLabel('returns.page.selectItems.noReasonsAvailable')
    }), quantity > 1 ? /*#__PURE__*/ React.createElement("div", {
        className: "return-item__selectors-container"
    }, /*#__PURE__*/ React.createElement(ConnectedFormSelect, {
        id: inputNames.quantity,
        name: inputNames.quantity,
        label: getLabel('returns.page.selectItems.field.quantity.label'),
        placeholder: getLabel('returns.page.selectItems.field.quantity.placeholder'),
        errorMessage: getLabel('returns.page.selectItems.field.quantity.error'),
        className: "return-item__select",
        options: createQuantitySelectOptions(quantity),
        initialState: {
            value: '1'
        },
        required: true
    })) : null)) : null);
};
var ReturnItem$1 = ReturnItem;

export { ReturnItem$1 as default };
//# sourceMappingURL=ReturnItem.js.map
